import request from '../utils/request';
const querystring = require('querystring') 
//获取列表数据 
export const fetchData = query => {  
    var list = request({
        url: 'comMember/getData.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//编辑
export const updateData = query => {  
    var list = request({
        url: 'comMember/updateSave.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};


export const delMemberDate = query => {  
    var list = request({
        url: 'comMember/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
 
 




